import React from "react";

export default function TaxiRates({
  headingTagline = "our Bus rates",
  headingTitle = (
    <>
      Our Flexible Bus <br /> Rates
    </>
  ),
  cards = defaultCards,
}) {
  return (
    <section className="taxi-rates-modern section-space" id="taxi-rates">
      <div className="container">
        {/* Heading */}
        <div className="sec-title sec-title--center mb-5">
          <h6 className="sec-title__tagline">{headingTagline}</h6>
          <h3 className="sec-title__title">{headingTitle}</h3>
        </div>

        {/* Cards */}
        <div className="row gutter-y-40">
          {cards.map((c) => (
            <div className="col-lg-4 col-md-6" key={c.id}>
              <div className="taxi-card-modern">
                {/* Image section */}
                <div className="taxi-card-modern__top">
                  <img src={c.imageUrl} alt={c.title} />
                </div>

                {/* Content section */}
                <div className="taxi-card-modern__body">
                  <h3>{c.title}</h3>
                  <p className="company">{c.company}</p>
                  <hr />
                  <ul>
                    <li>
                      <strong>Seater:</strong> {c.seater}
                    </li>
                    <li>
                      <strong>Per Km:</strong> {c.perKm}
                    </li>
                    <li>
                      <strong>Extra Hr:</strong> {c.extraHr}
                    </li>
                  </ul>
                 
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// --- Example Cards ---
const defaultCards = [
  {
    id: "urbania",
    title: "Luxury Force Urbania",
    company: "Amruta Travels Pvt Ltd",
    imageUrl: "/images/gallery/3.jpg",
    seater: "13 Seater Urbania",
    perKm: "₹37 / Km",
    extraHr: "₹250 / Hr",
    ctaHref: "/book",
  },
  {
    id: "traveller13",
    title: "35 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    imageUrl: "/images/gallery/5.jpg",
    seater: "35 Seater ",
    perKm: "₹36 / Km",
    extraHr: "₹250 / Hr",
    ctaHref: "/book",
  },
  {
    id: "traveller17",
    title: "50 Seater Bus",
    company: "Amruta Travels Pvt Ltd",
    imageUrl: "/images/gallery/8.jpg",
    seater: "50 Seater ",
    perKm: "₹50 / Km",
    extraHr: "₹250 / Hr",
    ctaHref: "/book",
  },
  
];
